import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { GetMaintenanceRequestsRequest } from './get-maintenance-requests'

export type ExportMaintenanceCsvRequest = GetMaintenanceRequestsRequest & {
  buildingId: number
}

// Note: a POST despite being a read - matches the legacy `/v2/maintenance/csv` endpoint
// (body-based filtering, same shape as `/v2/maintenance/filter`).
export const exportMaintenanceCsv = async (data: ExportMaintenanceCsvRequest): Promise<Blob> => {
  const response = await authAPI.post('/v2/maintenance/csv', data, { responseType: 'blob' })
  return response.data
}

export const useExportMaintenanceCsv = () => {
  return useMutation({
    mutationFn: exportMaintenanceCsv,
  })
}
